export const GNATTA_SDK = 'https://chat.system.gnatta.com/script/app.js';

export const AUTHENTICATION_STATUS = {
  AUTHENTICATED: 'AUTHENTICATED',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED'
} as const;
